import { Star } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export const RegularBadge = ({ stays, testId, className = "" }) => {
  if (!stays || stays < 2) return null;
  return (
    <Badge data-testid={testId} className={`bg-amber-100 text-amber-800 border-0 gap-1 font-medium ${className}`} title={`${stays} soggiorni`}>
      <Star className="w-3 h-3 fill-amber-500 text-amber-500" />Ospite abituale · {stays}
    </Badge>
  );
};

export const GuestNotesBox = ({ notes, testId }) => {
  if (!notes) return null;
  return (
    <div data-testid={testId} className="rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-900 whitespace-pre-wrap">
      <div className="text-[10px] uppercase tracking-wider font-semibold text-amber-700 mb-0.5">Note interne ospite</div>
      {notes}
    </div>
  );
};
